module.exports = __webpack_public_path__ + "media/images/tomato2-395ee42bb562fe8e16bc7a76b064dbde.jpg";